<a
    class="flex flex-col p-4 w-full hover:scale-105 transition-transform duration-200 cursor-pointer transform"
    [routerLink]="getNewsLink(blogPost())"
>
    <h2 class="mb-4 font-medium ~text-2xl/4xl">
        {{ blogPost().title }}
    </h2>
    <div class="md:flex ~gap-2/4">
        @defer {
            <img
                class="rounded-lg w-full md:w-52 md:h-64 object-cover aspect-[4/3]"
                [src]="
                    domHandler.getSmallestImageAsWebp(
                        blogPost().textImages[0].image
                    )
                "
                alt="{{ blogPost().textImages[0].image.alternativeText }} "
                [srcset]="
                    domHandler.generateSrcset(blogPost().textImages[0].image)
                "
                loading="lazy"
            />
        } @placeholder {
            <ngx-skeleton-loader
                class="block w-full md:w-52 h-[200px]"
                [theme]="{ height: '100%' }"
            ></ngx-skeleton-loader>
        }
        <div class="flex flex-col justify-between w-full ~gap-2/4">
            <p>{{ blogPost().date | customDate }}</p>
            <p class="mt-2 font-garamond text-xl leading-relaxed">
                {{
                    productService.getPreviewText(blogPost().textImages[0].text)
                }}
            </p>
            <app-button>{{ "blog.readMore" | translate }}</app-button>
        </div>
    </div>
</a>
